import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./DoctorHomeDiary.css";
import "../../overall.css";

function DoctorHomeDiarySkeleton() {
  return (
    <div>
      {/* TitleBar Skeleton */}
      <div style={{ marginBottom: "24px" }}>
        <Skeleton height={40} width={300} style={{ marginBottom: "8px" }} />
        <Skeleton height={20} width={200} />
      </div>

      {/* Summary Container */}
      <div className="sumContainer row flex justify-between">
        <div className="box-container w-[60%]">
          <Skeleton height={24} width={120} style={{ marginBottom: "12px" }} />
          
          {/* Stats Cards */}
          <div className="leftSumFlexContainer">
            <div className="stats-container row flex justify-start gap-10">
              {/* Studies Card */}
              <div className="statsCard stats-card-short">
                <Skeleton circle height={40} width={40} style={{ marginBottom: "8px" }} />
                <Skeleton height={16} width={60} style={{ marginBottom: "8px" }} />
                <Skeleton height={32} width={40} />
              </div>

              {/* Patients Card */}
              <div className="statsCard stats-card-short">
                <Skeleton circle height={40} width={40} style={{ marginBottom: "8px" }} />
                <Skeleton height={16} width={80} style={{ marginBottom: "8px" }} />
                <Skeleton height={32} width={40} />
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="w-[35%]">
          <Skeleton height={24} width={120} style={{ marginBottom: "12px" }} />
          <Skeleton height={48} width="100%" style={{ marginBottom: "12px" }} />
          <Skeleton height={48} width="100%" />
        </div>
      </div>

      {/* Inactive Patients Table Skeleton */}
      <div style={{ marginTop: "32px" }}>
        <Skeleton height={24} width={180} style={{ marginBottom: "16px" }} />
        <div>
          {[1, 2, 3, 4, 5].map((i) => (
            <Skeleton key={i} height={60} style={{ marginBottom: "8px" }} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default DoctorHomeDiarySkeleton;
